// US state full-name → 2-letter abbreviation map.
// Open-Meteo's geocoding returns admin1 as the full state name; this lets us
// display "NY" / "CA" / "TX" instead of "New York" / "California" / "Texas".
export const US_STATES = {
  Alabama: "AL",
  Alaska: "AK",
  "American Samoa": "AS",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  "District of Columbia": "DC",
  Florida: "FL",
  Georgia: "GA",
  Guam: "GU",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  "Northern Mariana Islands": "MP",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Puerto Rico": "PR",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  "U.S. Virgin Islands": "VI",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};

// Build a friendly label for a geocoding result.
// US locations:  "New York, NY, US"
// Other places:  "Madrid, Community of Madrid, ES"
export function buildLocationLabel(r) {
  if (!r) return "";
  const parts = [r.name];
  if (r.country_code === "US" && r.admin1) {
    parts.push(US_STATES[r.admin1] || r.admin1);
    parts.push("US");
  } else {
    if (r.admin1 && r.admin1 !== r.name) parts.push(r.admin1);
    parts.push(r.country_code || r.country);
  }
  return parts.filter(Boolean).join(", ");
}

// Build a short subtitle (without the city name) for the search dropdown.
// US:    "NY, US"     Non-US: "Community of Madrid, ES"
export function buildLocationSubtitle(r) {
  if (!r) return "";
  if (r.country_code === "US" && r.admin1) {
    return `${US_STATES[r.admin1] || r.admin1}, US`;
  }
  const parts = [];
  if (r.admin1 && r.admin1 !== r.name) parts.push(r.admin1);
  parts.push(r.country_code || r.country);
  return parts.filter(Boolean).join(", ");
}
